import { Reveal } from "@/components/Reveal";
import { Martini, GlassWater, Users, Truck, Sparkles, BookOpen } from "lucide-react";

const services = [
  {
    icon: Martini,
    title: "Signature Cocktails",
    body: "Custom-designed drink menus built around your event's theme, colors, and taste.",
    span: "lg:col-span-2",
  },
  {
    icon: Truck,
    title: "Full Mobile Setup",
    body: "Portable bars, glassware, ice, and premium spirits — delivered and styled.",
    span: "",
  },
  {
    icon: Users,
    title: "Pro Bartenders",
    body: "Certified, charismatic mixologists who keep the line short and the vibe high.",
    span: "",
  },
  {
    icon: GlassWater,
    title: "Zero-Proof Program",
    body: "Elevated mocktails so every guest gets the full craft experience.",
    span: "",
  },
  {
    icon: Sparkles,
    title: "Flair & Live Stations",
    body: "Smoke, torches, and tableside theatre that turn service into a show.",
    span: "lg:col-span-2",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
      data-testid="services-section"
    >
      <Reveal className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">What We Do</p>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
            Services, <span className="italic gold-shimmer">poured neat.</span>
          </h2>
        </div>
        <p className="text-[#a0a0a0] font-light max-w-sm">
          A full-service mobile bar for weddings, launches, and every celebration in between.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span}>
            <div
              data-testid={`service-card-${i}`}
              className="group h-full min-h-[220px] flex flex-col justify-between p-8 bg-[#0a0a0a] border border-[#222] hover:border-gold/50 hover:-translate-y-2 transition-all duration-500"
            >
              <s.icon className="text-gold" size={30} strokeWidth={1.2} />
              <div className="mt-10">
                <h3 className="font-heading text-2xl md:text-3xl mb-2">{s.title}</h3>
                <p className="text-[#a0a0a0] font-light text-sm leading-relaxed">{s.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
